const NestedTabs = () => {
  document.querySelectorAll(".xo2026-nested-tabs").forEach((section) => {
    section.querySelectorAll("[data-nested-tabs-panel]").forEach((panel) => {
      const buttons = [...panel.querySelectorAll("[data-nested-tab-button]")];
      const images = [...panel.querySelectorAll("[data-nested-tab-image]")];

      const activate = (id) => {
        buttons.forEach((button) => {
          const isActive = button.dataset.nestedTabButton === id;
          const item = button.closest(".xo2026-nested-tabs__subtab");

          item?.classList.toggle("is-active", isActive);
          button.setAttribute("aria-expanded", String(isActive));
        });

        images.forEach((image) => {
          const isActive = image.dataset.nestedTabImage === id;
          image.classList.toggle("is-active", isActive);
          image.hidden = !isActive;
        });
      };

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          activate(button.dataset.nestedTabButton);
        });
      });

      if (buttons[0]) {
        activate(buttons[0].dataset.nestedTabButton);
      }
    });
  });
};

export default NestedTabs;
